<template>
  <div class="subpage-nav">
    <container>
      <div class="subpage-nav__list">
        <div class="subpage-nav__item">
          <p class="subpage-nav__link" exact>
            <span class="btn-txt">
              {{ links.title }}
            </span>
          </p>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
export default {
  name: 'SubpageCategory',
  props: {
    links: Object
  },
  data () {
    return {
      isActive: false
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/subpage-nav";
</style>
